import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VideoPlayer from 'vue-video-player/src';

import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'


Vue.use(VideoPlayer)
Vue.use(ElementUI);


Vue.config.productionTip = false;
Vue.prototype.$URL = 'https://image.altener.cn/upload/official/'
Vue.prototype.$IMG = 'https://image.altener.cn/upload/backstage/image/'


Vue.prototype.$estimate = function () {
  if (window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )) {
    return true // 移动端
  } else {
    return false // PC端
  }
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js